import { render } from "./BasicPractiseTable.vue?vue&type=template&id=2e38a8e0"
import script from "./BasicPractiseTable.vue?vue&type=script&lang=js"
export * from "./BasicPractiseTable.vue?vue&type=script&lang=js"

import "./BasicPractiseTable.vue?vue&type=style&index=0&id=2e38a8e0&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__